import { OptionalProduct } from '~/core/models';

type WarrantyType = 'cabinet' | 'countertop';
type WarrantyInfoType = 'title' | 'content';

export const countertopWarrantyInfoContent = `
<p>
  The Granite Gold<sup>®</sup> Protection Plan, is an affordable, worry-free way to ensure your new countertops last for years to come.
</p>
<p>
  The 5 and 10-Year Protection Plans cover common accidental damages that aren't covered by the material warranties.
</p>
<p>Both plans are available for the following countertop product lines:</p>
<ul>
  <li>Quartz</li>
  <li>Granite</li>
  <li>Solid Surface</li>
</ul>
<p>What is covered<sup>1</sup>:</p>
<p><b>Household Stains</b></p>
<ul>
  <li>Food and Beverage</li>
  <li>Cosmetics</li>
  <li>Oils</li>
  <li>Rust</li>
  <li>Human and pet bodily fluids / waste<sup>2</sup></li>
</ul>
<p style="color: #1F1F1F"><b>Accidental Damage</b></p>
<ul>
  <li>Chipping, pitting, and scratches</li>
  <li>Etching (dulling surfaces)</li>
  <li>Hard water marks and deposits</li>
  <li>Caulking, grout, and joint expansion</li>
</ul>
<p style="font-style: italic; font-size: 12px; padding-inline-start: 40px;">
    1: Certain limits, conditions, obligations, and exclusions apply
    <br />
    2: Not including perspiration, hair oils, or body oils
</p>
`;

export const cabinetWarrantyInfoContent = `
<p>
  The Granite Gold<sup>®</sup> Cabinet Protection Plan is an affordable, worry-free way to ensure your new cabinets last for years to come.
</p>
<p>
  The 5 and 10-Year Protection Plans will take effect as soon as your cabinets are installed, and they're covered against accidental damage.
</p>
<p>What is covered<sup>1</sup>:</p>
<p><b>Household Stains</b></p>
<ul>
  <li>Food and Beverage</li>
  <li>Cosmetics</li>
  <li>Bleach</li>
  <li>Nail Polish</li>
  <li>Ink</li>
  <li>Liquid Marks</li>
</ul>
<p style="color: #1F1F1F"><b>Accidental Damage</b></p>
<ul>
  <li>Scuffs</li>
  <li>Chips</li>
  <li>Broken Slide, Hinge or Runner</li>
  <li>Scratches</li>
  <li>Loose Veneer</li>
  <li>Burns</li>
  <li>Heat marks</li>
  <li>Dents</li>
</ul>
<p style="font-style: italic; font-size: 12px; padding-inline-start: 40px;">
    1: Certain limits, conditions, obligations, and exclusions apply
</p>
`;

const warrantyInfo: Record<WarrantyType, Record<WarrantyInfoType, string>> = {
  cabinet: {
    title: 'GRANITE GOLD CABINET PROTECTION PLAN',
    content: cabinetWarrantyInfoContent,
  },
  countertop: {
    title: 'GRANITE GOLD PROTECTION PLAN',
    content: countertopWarrantyInfoContent,
  },
};

export const selectWarrantyInfo = (
  infoType: WarrantyInfoType,
  warrantyCandidate?: OptionalProduct
): string => {
  const subtype = warrantyCandidate?.qteSubCode?.toUpperCase();

  if (subtype?.includes('CABINET')) {
    return warrantyInfo.cabinet[infoType];
  }

  if (subtype?.includes('COUNTERTOP')) {
    return warrantyInfo.countertop[infoType];
  }

  // Parity fallback: keep output stable for unknown or missing subtype values.
  return warrantyInfo.countertop[infoType];
};
